import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';

import Paper from './paper';

class ResearchSection extends Component {
  onSectionEnter() {
    const { props } = this;
    if (props.section.url_safe_name !== props.currSection) {
      props.history.replace({ hash: '#' + props.section.url_safe_name });
    }
  }

  render() {
    const { props } = this;
    if (!props.filteredWorks || !props.filteredWorks.length) return null;

    return (
      <div id={props.section.url_safe_name} className="research-section">
        <h3>{props.section && props.section.display_name}</h3>

        <div>
          <Waypoint
            fireOnRapidScroll={false}
            onEnter={(e) => this.onSectionEnter(e)}
            scrollableAncestor={window}
            topOffset={1}
            bottomOffset={window.innerHeight - 50}
          >
            {this.renderPaper(props.filteredWorks[0])}
          </Waypoint>

          {props.filteredWorks.slice(1).map((work) => this.renderPaper(work))}
        </div>
      </div>
    );
  }

  renderPaper(work) {
    return (
      <div key={work.id}>
        <Paper
          title={work.display_name}
          thumbnailUrl={work.thumbnail_url}
          authors={work.ordered_authors}
          url={work.url}
          externalUrl={work.external_url}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ works }, { section }) => {
  return {
    filteredWorks: works // eslint-disable-next-line eqeqeq
      .filter(({ section_id }) => section_id == section.id)
      .sort((a, b) => a.display_order - b.display_order),
  };
};

export default connect(mapStateToProps)(ResearchSection);
